import {Component, OnDestroy, OnInit} from '@angular/core';
import { LoadingSpinnerService } from './_core/services/loading-spinner.service';
import { FeatureFlagService } from './_core/services/feature-flag.service';
import { find } from 'lodash-es';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private featureFlagService: FeatureFlagService,
    public loadingSpinnerService: LoadingSpinnerService
  ) {}
  title = 'CareFinDr';


  ngOnInit() {
    this.featureFlagService.initFeatureFlags();
  }

}

function getTenantFromUrl(): string {
  const hostname = window.location.hostname;
  // Examples:
  //let hostname = "stg-wahbe.carefindr.getconvergent.io"
  //let hostname = "wahbe.carefindr.getconvergent.io"

  if (hostname === 'localhost') {
    // return 'centerlight';
    // return 'riverspring';
    // return 'mddoh';
    // return 'villagecare';
    // return 'champion';
    // return 'elderservehealth';
	// set class on body for client theme change
	const bodyElem = document.querySelector("body");
  	bodyElem?.classList.add("centerlight");
    return 'centerlight';
  }

  const parts = hostname.split('.');
  let tenant = parts[0].toUpperCase();

  //TODO: HOTFIX for villagecare vanity url
  if(hostname === 'providersearch.villagecaremax.org') {
    tenant = 'villagecare';
  }

  // Remove environment prefix if present
  const envPrefix = find(['DEV', 'TST', 'STG'], (prefix) =>
    tenant.startsWith(`${prefix}-`)
  );

  // set class on body for client theme change
  const bodyElem = document.querySelector("body");
  bodyElem?.classList.add((envPrefix ? tenant.replace(`${envPrefix}-`, '') : tenant).toLowerCase());

  return (envPrefix ? tenant.replace(`${envPrefix}-`, '') : tenant).toLowerCase();
}
export const CURRENT_TENNANT = getTenantFromUrl();
